import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

interface MatchCardType {
    rabBetslipHeight: number | null;
    isFooterVisible: boolean;
}

export const MatchCardSection = withConfig(theme => styled('div', { label: 'MatchCardSection' })<MatchCardType>`
    background-color: ${theme.star.eventRow.bgColor};
    padding-bottom: ${({ rabBetslipHeight, isFooterVisible }):string => isFooterVisible === true ? '0' : rabBetslipHeight === null ? '0' : `${rabBetslipHeight}px`};
`);

interface RabHeaderPropsType {
    isYouDecideOpen: boolean;
    variant: DefaultComponentVariantType | null;
}

const setRabHeader = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            margin: 8px 0;
            padding: ${theme.star.padding.medium};
            @media ${theme.star.mediaQuery.tablet} {
                margin: 8px;
                border-radius: ${theme.star.radius.medium};
            }
        `;
    }
    return css`
        padding: 8px 16px 8px 8px;
        @media ${theme.star.mediaQuery.desktop} {
            padding: 6px 16px 6px 8px;
        }
    `;
};

export const RabHeader = withConfig(theme => styled('div', { label: 'RabHeader' })<RabHeaderPropsType>`
    ${({ variant }): SerializedStyles => setRabHeader(variant, theme)}
    align-items: center;
    background-color: ${({ isYouDecideOpen }):string => isYouDecideOpen ? theme.star.rabHeading.bgColorSecondary : theme.star.rabHeading.bgColor};
    color: ${({ isYouDecideOpen }):string => isYouDecideOpen ? theme.star.rabHeading.txtColorTertiary : theme.star.rabHeading.txtColor};
    display: flex;
    justify-content: space-between;
    position: relative;
`);

export const MatchCardContent = withConfig(theme => styled('div', { label: 'MatchCardContent' })`
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.medium};
    margin-bottom: 0;
    margin-top: -1px;
`);

interface MatchCardContentWrapperPropsType {
    variant: DefaultComponentVariantType | null;
    isYouDecideOpen: boolean;
    isFiltersAvailable: boolean;
}

const setMatchCardContentWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme, isYouDecideOpen: boolean, isFiltersAvailable: boolean): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            background-color: ${theme.star.marketHeader.bgColorSecondary};
            padding: ${theme.star.padding.medium};
            gap: ${theme.star.gap.large};
            margin: ${isFiltersAvailable ? '0 0 8px': '8px 0'};
            @media ${theme.star.mediaQuery.tablet} {
                margin: ${isFiltersAvailable ? '0 8px 8px 8px': '8px'};
                border-radius: ${isYouDecideOpen || !isFiltersAvailable ? theme.star.radius.medium :`0 0 ${theme.star.radius.medium} ${theme.star.radius.medium}`};
                gap: ${theme.star.gap.xxLarge};
            }
            @media ${theme.star.mediaQuery.desktop} {
                gap: ${theme.star.gap.large};
            }
        `;
    }
    return css``;
};

export const MatchCardContentWrapper = withConfig(theme => styled('div', { label: 'MatchCardContentWrapper' })<MatchCardContentWrapperPropsType>`
    ${({ variant, isYouDecideOpen, isFiltersAvailable }): SerializedStyles => setMatchCardContentWrapper(variant, theme, isYouDecideOpen, isFiltersAvailable)}
    display: flex;
    overflow: hidden;
`);

interface RabMarketsContentPropsType {
    isYouDecideOpen: boolean;
    widthContent: number | undefined;
    rabAvailable: boolean;
    variant: DefaultComponentVariantType | null;
}

export const MatchCardContentMarkets = styled('div', { label: 'MatchCardContentMarkets' })<RabMarketsContentPropsType>`
    flex-shrink: 0;
    height: ${({ isYouDecideOpen, rabAvailable }):string => isYouDecideOpen && rabAvailable ? '0' : 'auto'};
    position: relative;
    right: ${({ isYouDecideOpen, widthContent, rabAvailable }):string => !isYouDecideOpen || !rabAvailable ? '0' : widthContent === undefined ? '0' : `${widthContent}px`};
    transition: right .3s ease 0s;
    width: 100%;
`;

const setMatchCardContentMarketsRAB = (variant: DefaultComponentVariantType | null, theme: EmotionTheme, isYouDecideOpen: boolean): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            display: flex;
            flex-flow: column nowrap;
            gap: ${theme.star.gap.medium};
            overflow: hidden;
            @media ${theme.star.mediaQuery.desktop} {
                padding-bottom: ${isYouDecideOpen ? '182px' : '0'};
            }
        `;
    }
    return css`    
        @media ${theme.star.mediaQuery.desktop} {
            padding-bottom: ${isYouDecideOpen ? '128px' : '0'};
        }
    `;
};

export const MatchCardContentMarketsRAB = withConfig(theme => styled(MatchCardContentMarkets, { label: 'MatchCardContentMarketsRAB' })<RabMarketsContentPropsType>`
    height: ${({ isYouDecideOpen }):string => isYouDecideOpen ? 'auto' : '0'};
    ${({ variant, isYouDecideOpen }): SerializedStyles => setMatchCardContentMarketsRAB(variant, theme, isYouDecideOpen)}
`);

export const MatchCardInfoWrapper = styled('div', { label: 'MatchCardInfoWrapper' })`
    padding: 30px 5px;
    position: relative;
    text-align: center;
`;
